import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import SearchBrandProdItem from '../../components/search/SearchBrandProdItem'
import BrBrandProdItem from '../../components/br/BrBrandProdItem'
import { useHistory } from 'react-router-dom';
import Slider from "react-slick";
import {isMobileOnly} from 'react-device-detect';
import { useEffect } from 'react';
import { reqEsProdAction } from '../../modules/es/esItemModule';
import SlideBtn from '../../components/common/button/SlideBtn';

const EstimatePdListBlock = styled.div`
    ${isMobileOnly?`
    overflow: scroll;
    overflow-y: hidden;
    `:`
    
    `};

    margin-top: 20px;
    width: 100%;
    position: relative;
    
`;

const EstimatePdListSubBlock = styled.div`
    .slick-arrow.slick-prev {
        ${isMobileOnly?"":"left: -5px"};
    }
`;


const EstimatePdUlBlock = styled.ul`
    float:left;
    width: max-content;
`;

const EstimatePdliBlock = styled.li`
    float: left;
`;

const isNull = (value) => {
    return value !== null;
}

const EsItemsListBestContainer = ({refSlider}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { esProdItems } = useSelector(
        ({ loadingReducer, esItemsReducer }) => ({
            loading: loadingReducer['esitem/REQ_ES_ST'],
            esProdItems: esItemsReducer.esProdItems,
        })
    );

    useEffect(() => {
        dispatch(reqEsProdAction());
    }, [dispatch])

    if (esProdItems === null || esProdItems === undefined) {
        return <div />;
    }

    /* const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: false,
        //swipeToSlide: true,
      }; */
      const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        // variableWidth: true,
        slidesToShow: 4,  // 1 slide if mobile
        slidesToScroll: 1,
        arrows: true,
        nextArrow: <SlideBtn className="left" right={true} top="38%"/>,
        prevArrow: <SlideBtn className="left" top="38%" style={{left: '-3px'}}/>,
        //swipeToSlide: true
      };
    const handleImgClick = (id) => {
        history.push('/prod?prodid=' + id);
    }

    /* if (Object.keys(brInfo).includes('prods') === false || brInfo.prods === undefined) {
        return (
            <EstimatePdListLiBlock>
                <SearchBrandHomeItem img={brInfo.brnd_logo_url} brandInfo={brInfo.brnd_han}
                idHome={brInfo.id} total={brInfo.totalnum} />
            </EstimatePdListLiBlock>
        );
    } */

    const getMPdList = () => {
        return (

                <EstimatePdUlBlock className = "clearfix">
                {
                    esProdItems.map((prod) => {
                        return <BrBrandProdItem key={prod.prdct_id}
                            img={prod.repr_img}
                            prodname={prod.prdct_nm}
                            sale_price={prod.sale_price}
                            prdct_price={prod.prdct_price}
                            prdct_id={prod.prdct_id}
                            onClick={() => handleImgClick(prod.prdct_id)}
                        />
                    })
                }
                </EstimatePdUlBlock>
        )
    }

    const getProductListSlider = () => {
        return (
            <EstimatePdListSubBlock className = "best_item-list best_item-slide2 clearfix slick-initialized slick-slider">
                <Slider ref={refSlider} {...settings} >
                        {
                            esProdItems.map((prod) => {
                                return (
                                <SearchBrandProdItem key={prod.prdct_id}
                                    img={prod.repr_img}
                                    prodname={prod.prdct_nm}
                                    sale_price={prod.sale_price}
                                    prdct_price={prod.prdct_price}
                                    prdct_id={prod.prdct_id}
                                    onClick={() => handleImgClick(prod.prdct_id)}
                                />
                            )
                            })
                        }
                </Slider>
            </EstimatePdListSubBlock>
        )
    }
    return (
        <div>
        <EstimatePdListBlock className = "sr-brand_item2 margin_b-50">
            {isMobileOnly?
                getMPdList()
            :
                getProductListSlider()
            }
        </EstimatePdListBlock>
        </div>
    );

};

export default EsItemsListBestContainer;
